import { SVGProps } from 'react';
const MeetingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" {...props}>
    <rect x="0.5" y="0.5" width="47" height="47" rx="13.5" fill="#FFEDD5" />
    <rect x="0.5" y="0.5" width="47" height="47" rx="13.5" stroke="#F2C2A1" />
    <circle cx="24.0003" cy="15.9993" r="5.33333" stroke="#E46105" strokeWidth="2" />
    <path
      d="M32 20.0007C34.2091 20.0007 36 18.5083 36 16.6673C36 14.8264 34.2091 13.334 32 13.334"
      stroke="#E46105"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M16 20.0007C13.7909 20.0007 12 18.5083 12 16.6673C12 14.8264 13.7909 13.334 16 13.334"
      stroke="#E46105"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <ellipse cx="24" cy="30.6673" rx="8" ry="5.33333" stroke="#E46105" strokeWidth="2" />
    <path
      d="M34.667 33.3327C37.006 32.8198 38.667 31.5208 38.667 29.9993C38.667 28.4779 37.006 27.1789 34.667 26.666"
      stroke="#E46105"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M13.333 33.3327C10.994 32.8198 9.33301 31.5208 9.33301 29.9993C9.33301 28.4779 10.994 27.1789 13.333 26.666"
      stroke="#E46105"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export default MeetingIcon;
